export const BOT_TYPE_LABELS = {
    ALGO: 'Algo',
    GRID: 'Grid',
    SCHEDULED: 'Scheduled',
    CONDITION: 'Condition',
};

export function getBotTypeLabel(type) {
    return BOT_TYPE_LABELS[type] || type;
}

export function getBotStatusClass(bot) {
    if (bot.statusLabel === 'SCHEDULED') {
        return bot.isActive ? 'text-info' : 'text-danger';
    }
    return bot.isActive ? 'text-success text-green-500' : 'text-danger text-red-500';
}

export function getCompositionSummary(bot) {
    if (!bot.composition) return '—';
    const parts = [];
    if (bot.composition.monitorName) parts.push(`Monitor: ${bot.composition.monitorName}`);
    if (bot.composition.buyAutomationName) parts.push(`Buy: ${bot.composition.buyAutomationName}`);
    if (bot.composition.sellAutomationName) parts.push(`Sell: ${bot.composition.sellAutomationName}`);
    return parts.length ? parts.join(' · ') : '—';
}

export function isGridBot(bot) {
    return bot.type === 'GRID'
        || (bot.actions && bot.actions.length && bot.actions[0].type === 'GRID');
}

export function getBotEditPath(bot) {
    if (bot.type === 'ALGO') return `/unified-setup?botId=${bot.sourceId}`;
    if (bot.type === 'GRID') return `/grid?automationId=${bot.sourceId}`;
    if (bot.type === 'SCHEDULED') return `/scheduled?automationId=${bot.sourceId}`;
    return null;
}

export function getBotPerformancePath(bot) {
    return `/bots/${bot.sourceType}/${bot.sourceId}/performance`;
}

export function getAutomationIdsForBot(bot) {
    if (!bot) return [];

    if (bot.sourceType === 'strategy') {
        const ids = [];
        if (bot.composition?.buyAutomationId) ids.push(bot.composition.buyAutomationId);
        if (bot.composition?.sellAutomationId) ids.push(bot.composition.sellAutomationId);
        return ids;
    }

    if (bot.sourceId) return [bot.sourceId];
    return [];
}

export function isBotSelected(bot, automationIds = []) {
    const ids = getAutomationIdsForBot(bot);
    return ids.length > 0 && ids.every((id) => automationIds.includes(id));
}

export function toggleBotSelection(bot, automationIds = [], checked) {
    const ids = getAutomationIdsForBot(bot);
    if (!ids.length) return automationIds;

    if (checked) {
        return [...new Set([...automationIds, ...ids])];
    }

    const remove = new Set(ids);
    return automationIds.filter((id) => !remove.has(id));
}